// extracted by mini-css-extract-plugin
export default {"loading_wrapper":"loading_loading_wrapper__87XVQ","spin":"loading_spin__OW+R2"};